import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function AdminEmailLogs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/email-logs").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <h1 className="font-display text-3xl font-bold mb-4">Email logs</h1>
      <div className="card-flat overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr><th className="text-left p-3">When</th><th className="text-left p-3">Kind</th><th className="text-left p-3">To</th><th className="text-left p-3">Order</th><th className="text-left p-3">Delivery</th></tr>
          </thead>
          <tbody>
            {rows.map((l,i) => (
              <tr key={i} className="border-t border-slate-100">
                <td className="p-3 font-mono text-xs">{l.at?.slice(0,16).replace("T"," ")}</td>
                <td className="p-3">{l.kind}</td>
                <td className="p-3">{l.to}</td>
                <td className="p-3 font-mono text-xs">{l.order_id?.slice(0,8)}</td>
                <td className="p-3">{l.success ? <span className="text-emerald-700 flex items-center gap-1"><CheckCircle2 className="h-4 w-4"/> Sent</span> : <span className="text-red-600 flex items-center gap-1"><XCircle className="h-4 w-4"/> Failed</span>}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="5" className="p-10 text-center text-slate-500">No email activity yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
